import { Box, Typography, Container, Card, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import { useNavigate, useLocation } from 'react-router-dom';

export default function UnlockSuccessScreen() {
  const navigate = useNavigate();
  const location = useLocation();

  const passKey = location.state?.passKey || 'N/A';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '400px',
        margin: '0 auto',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: 2.5,
          px: 2,
          mt: 1,
          justifyContent: 'space-between',
        }}
      >
        <IconButton
          sx={{
            color: '#000',
            p: 0,
            mr: 2,
          }}
          aria-label="Go back"
          onClick={() => navigate('/home')}
        >
          <ArrowBackIcon sx={{ fontSize: 24 }} />
        </IconButton>

        <IconButton
          aria-label="Support"
          component="a"
          href="tel:02045259955"
          sx={{
            color: '#000',
            p: 0,
            cursor: 'pointer',
            backgroundColor: '#F8F8F8',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            width: 48,
            height: 48,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <HeadsetMicIcon sx={{ fontSize: 24 }} />
        </IconButton>
      </Box>

      <Container
        maxWidth="sm"
        sx={{
          flex: 1,
          px: 3,
          pb: 4,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            fontSize: '28px',
            color: '#000',
            mb: 4,
            lineHeight: 1.3,
            textAlign: 'center',
          }}
        >
          Your Room has been Successfully Unlocked
        </Typography>

        <Card
          sx={{
            borderRadius: '28px',
            mb: 6,
            backgroundColor: '#2e7d7b',
            boxShadow: 'none',
          }}
        >
          <Box
            sx={{
              py: 2.5,
              px: 3,
              textAlign: 'center',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: 'white',
                fontSize: '16px',
                fontWeight: 500,
              }}
            >
              Pass Key: {passKey}#
            </Typography>
          </Box>
        </Card>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 6,
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 120,
              color: '#4caf50',
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}
